import { DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs } from 'cerialize';
import { ITransitProgramRequirementStatus } from '../interfaces';
import { SigningTemplate } from './signing-template';

export class SigningTemplateStatus implements ITransitProgramRequirementStatus {
  @autoserialize
  driverId: number;

  @autoserialize
  transitProgramCode: string;

  @autoserialize
  signingTemplateName: string;

  @autoserializeAs(SigningTemplate)
  signingTemplate: SigningTemplate;

  @autoserialize
  status: string;

  @autoserializeAs(Date)
  requiredByDate: Date;

  static OnSerialized(instance: SigningTemplateStatus, json: any): void {
    if (!isNullOrUndefined(instance.requiredByDate)) {
      json.requiredByDate = DateUtil.serializeLocalDate(instance.requiredByDate);
    }
  }

  static OnDeserialized(instance: SigningTemplateStatus, json: any): void {
    if (!isNullOrUndefined(json['requiredByDate'])) {
      instance.requiredByDate = DateUtil.deserializeLocalDate(json['requiredByDate']);
    }
  }
}
